const OCR_COUNT = 'OCR_COUNT';
const OCR_PDF_COUNT = 'OCR_PDF_COUNT';
const OCR_STACK = 'OCR_STACK_1';
const USER_LANGUAGE = 'USER_LANGUAGE';
const GOOGLE_AUTH_KEY = 'GOOGLE_AUTH_KEY';

export { OCR_COUNT, OCR_PDF_COUNT, OCR_STACK, USER_LANGUAGE, GOOGLE_AUTH_KEY };
